/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartElement = document.querySelector('ajax-cart');

    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    this.giftWrap = this.closest('body').querySelector('[name="is_gift_wrap"]');
    window.addEventListener('DOMContentLoaded', () => {
          document.querySelectorAll('.wait-text').forEach((text)=>{text.classList.add('d-none')});
          document.querySelectorAll('.add-cart-text').forEach(text => text.classList.remove('d-none'));
          document.querySelectorAll('[data-add_to_cart]').forEach(button => button.classList.remove('disabled'));
    });
    this.variantRadioOptions = this.querySelectorAll('[data-size-custom]');
    
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    const pdpContainer = this.closest('.product-details-wrapper');

    
    let variantsHasRadioOptions = true;

    if (this.variantRadioOptions.length > 0) {
      
      this.variantRadioOptions.forEach(ele => {
        if (ele.querySelector('input:checked') == null) {
          ele.querySelector('.bs-form-label').classList.add('text-danger');
          variantsHasRadioOptions = false;
          ele.querySelector('.warning-message').classList.remove('d-none');
          return false;
          
        } else {
          ele.querySelector('.bs-form-label').classList.remove('text-danger');
          ele.querySelector('.warning-message').classList.add('d-none');
        }
      });
    }
    if (!variantsHasRadioOptions) { 
      document.querySelector('[data-product--options]')?.scrollIntoView({
            behavior: 'smooth'
        });
      return false };

 
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    addItems.push(JSON.parse(serializeForm(this.form)))
    if(pdpContainer){
      let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsEle.forEach((addOn)=>{
        if(!addOn.disabled){
          let addOnParent = addOn.closest('addons-form');
          let addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
    }

    const body = JSON.stringify({
      items: addItems
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(() => {
        if(document.querySelector('#PopupModal-quickshop')){
          document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
        }
        this.cartElement.getCartData('open_drawer');
        if(qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        if (this.giftWrap && this.giftWrap.checked) {
          let WrapBody = {id: this.giftWrap.dataset.productId,quantity: 1};
          fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body:JSON.stringify(WrapBody)})
          .then(res =>res.json())
          then(data => console.log(data));
        }
      });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if(action == 'decrease' && currentQty <= 1){
        return false;
    }else if(action == 'decrease'){
        finalQty = currentQty - 1;
    }else{
        finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
    if(this.formType == 'product-page') this.onVariantChange('load');
    if(this.formType == 'product-toolbar') this.onVariantChange('load');
    if(this.formType == 'grid') this.onVariantChange('load');

    this.addEventListener('change', this.onVariantChange.bind(this));

  }

  onVariantChange(_event) {
    if(this.formType == 'grid'){
      this.setCurrentGridVariant();
    }else{
    this.setCurrentVariant();
    }
    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
    if(this.formType == 'grid') window.globalVariables.product.currentVariant = this.currentVariant;
    if(this.formType == 'product-toolbar') window.globalVariables.product.currentVariant = this.currentVariant;
    if(this.formType != 'grid'){
      if (!this.currentVariant) {
        this.toggleAddButton('disable',_event);
        // Variant name update
        let options = this.form.querySelectorAll('[data-optionindex]');
        options.forEach(option => {
          let lableID = 'option'+option.dataset.optionindex;
          const selectedValue = option.querySelector('input[type="radio"]:checked');
          const lable = option.querySelector('.selected-option');
          if(!lable || !lableID || !selectedValue) return;
          lable.innerHTML = selectedValue.value;
        });
      } else {
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
        this.updateURLandID(this.currentVariant);
        this.toggleAddButton('enable'),_event;

        // update selling plan id
        let sellingPlanEle = this.form.querySelector('[name="selling_plan"]');
        if (sellingPlanEle) {
          let hasSellingPlan = this.currentVariant?.selling_plan_allocations[0]?.selling_plan_id;
          if (hasSellingPlan) {
            sellingPlanEle.value = hasSellingPlan;
            sellingPlanEle.disabled = false;
          } else {
            sellingPlanEle.value = '';
            sellingPlanEle.disabled = true;
          }
        }
      }
    }
    else{
      if (this.available == 'false') {
        this.toggleGridAddButton('disable');
        // Variant name update
        let options = this.form.querySelectorAll('[data-optionindex]');
        options.forEach(option => {
          let lableID = 'option'+option.dataset.optionindex;
          const selectedValue = option.querySelector('input[type="radio"]:checked');
          const lable = option.querySelector('.selected-option');
          if(!lable || !lableID || !selectedValue) return;
          lable.innerHTML = selectedValue.value;
        });
      } else {
          if(_event != 'load') {
            const productGrid = this.closest('[data-product-grid]');
            this.renderGridProductInfo(this.currentVariant, this.featuredImage, this.price, this.salePrice, productGrid);
            this._updateLinks(this.currentVariant, productGrid);
            this.updateURLandID(this.currentVariant);
          }
          this.toggleGridAddButton('enable');
      }
    }
    let currentVariantJson = this.currentVariant;
    if (typeof(currentVariantJson) == 'string') {
      if (this.variant_json) {
        currentVariantJson = JSON.parse(this.variant_json.textContent).filter(variant => {return variant.id == this.currentVariant})[0];
      }
    }
    // update selling plan id
    let sellingPlanEle = this.form.querySelector('[name="selling_plan"]');
    if (sellingPlanEle) {
      let hasSellingPlan = currentVariantJson?.selling_plan_allocations[0]?.selling_plan_id;
      if (hasSellingPlan) {
        sellingPlanEle.value = hasSellingPlan;
        sellingPlanEle.disabled = false;
      } else {
        sellingPlanEle.value = '';
        sellingPlanEle.disabled = true;
      }
    }

  }

  _updateLinks(currentVariant, productGrid){
    if(!currentVariant || !productGrid) return;
    const variantURL = '?variant=' + currentVariant;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });

    return options;
  }

  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      const selectedRadio = Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)'))
        .find((radio) => radio.checked);
        
      return selectedRadio?.value;
    }).filter(Boolean);
  }

 setCurrentGridVariant()
 {
  this.currentVariant;
  this.featuredImage;
  this.salePrice;
  this.price;
  this.available;
  this.form.querySelectorAll('.variant_selector').forEach((selector)=>{
    this.available = selector.options[selector.selectedIndex].getAttribute('data-available');
    this.price = selector.options[selector.selectedIndex].getAttribute('data-price');
    this.salePrice = selector.options[selector.selectedIndex].getAttribute('data-salePrice');
    this.featuredImage = selector.options[selector.selectedIndex].getAttribute('data-featuredImage');
    this.currentVariant = selector.value;
 })
}
  setCurrentVariant() {
    // get all current values from selectors
    
    this.currentVariant = false;
    let  options=[];
    // let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();
    let isSelectOnly=this.form.querySelectorAll('.variant_selector');
    let isRadioOnly=this.form.querySelectorAll('input[type="radio"]');
    let isBoth=(isSelectOnly.length && isRadioOnly.length) ? true : false;
    let dataOption = document.querySelector('[data-option-name]');
    let defaultOption = dataOption ? dataOption.getAttribute('data-option-name') : null;
    if (isBoth) {

    if(defaultOption === 'color'){
        this.form.querySelectorAll('.variant_selector').forEach((selector)=>{
          options.push(selector.value);
        });

        this.form.querySelectorAll('input[type="radio"]:checked').forEach((selector)=>{
          options.push(selector.value);
        });
      } else {
        this.form.querySelectorAll('input[type="radio"]:checked').forEach((selector)=>{
          options.push(selector.value);
        });
        this.form.querySelectorAll('.variant_selector').forEach((selector)=>{
          options.push(selector.value);
        });
      }
    }else{
      options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();
    }

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });
      // assign variant details to this.currentVariant if all options are present
      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }

  updateURLandID(currentVariant) {
    if (!currentVariant) return;
    // update query string with latest variant ID
    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    if(this.formType == 'grid'){
    input.value = currentVariant;
    }
    else{
      input.value = currentVariant.id;
    }
  }


renderGridProductInfo(currentVariant, featured_image, price , salePrice, container ){
       // Price Update
       let compare_price = salePrice;
       let priceElement = container.querySelector('[data-currentPrice]');
       let comparePriceElement = container.querySelector('[data-comparePrice]');
   
       if(priceElement) priceElement.innerHTML = price;
       if(comparePriceElement) {
         comparePriceElement.innerHTML = compare_price;
         if(currentVariant.compare_at_price <= 0){
           comparePriceElement.style.display = 'none';
         }else{
           comparePriceElement.style.display = 'block';
         }
       }
       // Grid Image Update on variant selection
         if(!featured_image) return;
         const featuredImage = container.querySelector('[data-feauredImage]');
         let updatedSrc = featured_image;
         if(updatedSrc){
           featuredImage.src = updatedSrc;
           featuredImage.srcset = updatedSrc;
         }
  }


  renderProductInfo(currentVariant, container) {

    if(!currentVariant || !container) return;

    // Price Update
    let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if(priceElement) priceElement.innerHTML = price;
    if(comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if(currentVariant.compare_at_price <= 0){
        comparePriceElement.style.display = 'none';
      }else{
        comparePriceElement.style.display = 'block';
      }
    }

    // Grid Image Update on variant selection
    if(this.formType == 'grid'){
      if(!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if(updatedSrc){
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    }else{
      if(!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(`.product--media[data-mediaID="${imageID}"]`);
      if(this.formType == 'quickshop'){
        imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${imageID}"]`);
      }
      if(!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if(quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if(productSlider)  productSlider.slideTo(slideIndex, 2000, true);
    }

    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option'+option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if(!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
    });
  }

  toggleGridAddButton(status){
    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-cart-text'))
        this.addBtn.querySelector('.add-cart-text').textContent = window.variantStrings.unavailable;
    }
    else{
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-cart-text').textContent = window.variantStrings.upsellAddText;
    }
  }
  }


  toggleAddButton(status,_event) {
    if (!this.addBtn) return;
    if (status == 'disable') {
      console.log(_event);
      
      if(this.addBtn.querySelector('.add-cart-text'));
      if (_event == 'load') {
        this.addBtn.querySelector('.add-cart-text').textContent = window.variantStrings.upsellAddText;
      }else{
        this.addBtn.querySelector('.add-cart-text').textContent = window.variantStrings.unavailable;
        this.addBtn.setAttribute('disabled', true);
      }
        
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-cart-text'))
        this.addBtn.querySelector('.add-cart-text').textContent = window.variantStrings.soldOut;
        document.querySelectorAll('.restockify-notify-button').forEach((btn)=>{
          btn.classList.remove('d-none');
        })
    } else {
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-cart-text').textContent = window.variantStrings.upsellAddText;
      }else{
        if(this.addBtn.querySelector('.add-cart-text')!=null){
        this.addBtn.querySelector('.add-cart-text').innerHTML = `<span class="icon-add-to-cart text-white me-2 fw-bolder"></span>${window.variantStrings.addToCart}`;
        document.querySelectorAll('.restockify-notify-button').forEach((btn)=>{
          btn.classList.add('d-none');
        })
        }
      }
    }
  }
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}

  customElements.define('variant-selects', VariantSelects);

  class VariantRadios extends VariantSelects {
    constructor() {
      super();
      this.form = this.closest('form') || this.querySelector('.form-element');
      this.formType = this.form.dataset.format;

      const colorSwatchContainer = this.querySelector('.color-swatch');
      if(colorSwatchContainer){
        const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
        colorSwatches.forEach(swatch => {
          let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
          let swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
        });
      }
    }
  }
  customElements.define('variant-radios', VariantRadios);